import cn from "clsx";
import { twMerge } from "tailwind-merge";
import React, { useCallback, useState } from "react";

const StarRating = ({
  value,
  totalStars,
  onStarClick,
  handleBlur,
  error,
  disabled,
}) => {
  const [rating, setRating] = useState(value);
  const handleClick = useCallback(
    (newValue) => {
      const newRating = rating === newValue ? 0 : newValue;
      setRating(newRating);
      onStarClick(newRating);
    },
    [rating, onStarClick]
  );

  const stars = Array.from({ length: totalStars }, (_, index) => (
    <i
      onClick={() => !disabled && handleClick(index + 1)}
      key={index}
      className={twMerge(
        cn(
          "fa-solid fa-star cursor-pointer text-gray-300 mr-1 h-10 w-10 text-lg",
          {
            "text-yellow-300": index < rating,
            "text-red-300": !!error,
            "cursor-not-allowed": disabled,
          }
        )
      )}
    ></i>
  ));

  return (
    <>
      <div
        className="flex w-full"
        tabIndex="0"
        onBlur={() => !disabled && handleBlur()}
      >
        {stars}
      </div>
      {!!error && <span className="text-red-600 text-sm">{error}</span>}
    </>
  );
};

export default StarRating;
